import { AnyAction } from 'redux';
import { GlobalizationActionTypes, GlobalizationState } from '../models/globalization-model';

const InitialState: GlobalizationState = {
    currentlanguage: 'en',
};

export const globalizationReducer = (state = InitialState, action: AnyAction): GlobalizationState => {

    switch (action.type) {
        case GlobalizationActionTypes.SET_CURRENT_LANGUAGE:
			return {
                ...state,
                currentlanguage: action.payload,
			};
		default: return state;
	}
};

export const setCurrentLanguage = (language: string): AnyAction => ({
    type: GlobalizationActionTypes.SET_CURRENT_LANGUAGE,
    payload: language,
});
